import BaseSpinner from './BaseSpinner.vue';
import CopiedButton from './CopiedButton.vue';
import ResultMessage from './ResultMessage.vue';
import BaseDialog from './BaseDialog.vue';
import LangSwitch from './LangSwitch.vue';

export default [BaseSpinner, CopiedButton, ResultMessage, BaseDialog, LangSwitch];
